import request from '@/utils/request'

let PlusApi = {

    /*插件列表*/
    plusList(data) {
        return request._post('/shop/plus.plus/index', data);
    },
    /*入驻申请列表*/
    saleList(data) {
        return request._post('/shop/plus.agent.apply/index', data);
    },
    /*分销商审核*/
    editApplyStatus(data) {
        return request._post('/shop/plus.agent.apply/editApplyStatus', data);
    },
    /*实名认证列表*/
    certifyList(data) {
        return request._post('/shop/plus.certification.apply/index', data);
    },
    /*实名认证详情*/
    certifyDetail(data) {
        return request._get('/shop/plus.certification.apply/detail', data);
    },
    /*审核*/
    editCertifyStatus(data) {
        return request._post('/shop/plus.certification.apply/editApplyStatus', data);
    },
    /*审核*/
    editGradeOrderStatus(data) {
        return request._post('/shop/user.grade/editApplyStatus', data);
    },
    /*分销商列表*/
    agentList(data) {
        return request._post('/shop/plus.agent.user/index', data);
    },
    /*查看下级用户*/
    agentUserFans(data) {
        return request._post('/shop/plus.agent.user/fans', data);
    },
    /*修改分销商*/
    agentUserEdit(data) {
        return request._post('/shop/plus.agent.user/edit', data);
    },
    /*删除分销商*/
    deleteagent(data) {
        return request._post('/shop/plus.agent.user/delete', data);
    },
    /*分销订单*/
    agentOrder(data) {
        return request._post('/shop/plus.agent.order/index', data);
    },
    /*提现申请*/
    cash(data) {
        return request._post('/shop/plus.agent.cash/index', data);
    },
    /*分销商提现审核*/
    cashSubmit(data) {
        return request._post('/shop/plus.agent.cash/submit', data);
    },
    /*微信打款*/
    WxPay(data) {
        return request._post('/shop/plus.agent.cash/wechat_pay', data);
    },
    /*分销商确认打款*/
    money(data) {
        return request._post('/shop/plus.agent.cash/money', data);
    },

    /*分销设置*/
    agentSet(data) {
        return request._post('/shop/plus.agent.setting/index', data);
    },
    /*分销设置-基础设置*/
    basic(data) {
        return request._post('/shop/plus.agent.setting/basic', data);
    },
    /*分销设置-分销商条件*/
    condition(data) {
        return request._post('/shop/plus.agent.setting/condition', data);
    },
    /*分销设置-佣金设置*/
    commission(data) {
        return request._post('/shop/plus.agent.setting/commission', data);
    },
    /*分销设置-佣金设置*/
    settlement(data) {
        return request._post('/shop/plus.agent.setting/settlement', data);
    },
    /*分销设置-自定义文字*/
    words(data) {
        return request._post('/shop/plus.agent.setting/words', data);
    },
    /*分销设置-申请协议*/
    license(data) {
        return request._post('/shop/plus.agent.setting/license', data);
    },
    /*分销设置-页面背景图*/
    background(data) {
        return request._post('/shop/plus.agent.setting/background', data);
    },
    /*分销设置-模板消息*/
    templateMsg(data) {
        return request._post('/shop/plus.agent.setting/templateMsg', data);
    },
    /*分销设置-分销海报*/
    SaveBackground(data) {
        return request._post('/shop/plus.agent.setting/qrcode', data);
    },
    /*分销设置-获取分销海报*/
    GetBackground(data) {
        return request._get('/shop/plus.agent.setting/qrcode', data);
    },
    /*获取规则列表*/
    rulesList(data) {
        return request._get('/shop/plus.agent.setting/rulesList', data);
    },
    /* 保存规则 */
    rulesSave(data) {
        return request._post('/shop/plus.agent.setting/rulesSave', data);
    },
    /* 删除规则 */
    rulesDelete(data) {
        return request._post('/shop/plus.agent.setting/rulesDelete', data);
    },
    /*授权证书列表*/
    certificateList(data) {
        return request._post('/shop/plus.certificate.certificate/index', data);
    },
    /*审核授权证书*/
    editCertificateStatus(data) {
        return request._post('/shop/plus.certificate.certificate/auditCert', data);
    },
    /*添加授权证书*/
    addCertificate(data) {
        return request._post('/shop/plus.certificate.certificate/add', data);
    },
    /*编辑授权证书*/
    editCertificate(data) {
        return request._post('/shop/plus.certificate.certificate/edit', data);
    },
    getCertConfig(data){
        return request._get('/shop/plus.certificate.certificate/fetchData', data);
    },
    /*编辑授权证书设置*/
    setCertificate(data) {
        return request._post('/shop/plus.certificate.certificate/editSetData', data);
    },
    /*查询推广码*/
    findPosterCode(data) {
        return request._post('/shop/plus.agent.apply/getPosterCode', data);
    },
    /*重新制作推广码*/
    remakeCode(data) {
        return request._post('/shop/plus.agent.apply/remakeCode', data);
    },
    /*重新制作推广码*/
    remakeQrcode(data) {
        return request._post('/shop/plus.agent.apply/remakeQrcode', data);
    },
    /*制作授权证书*/
    makeCertImg(data) {
        return request._post('/shop/plus.certificate.certificate/makeImgCert', data);
    },
      genPlus(data) {
        return request._post('/shop/plus.plus/genPlus', data);
    },
    /*移动应用分类*/
    moveCategory(data) {
        return request._post(
            '/shop/plus.plus/moveCategory',
            data
        );
    },

    /*新增/编辑应用分类*/
    categorySave(data) {
        return request._post(
            '/shop/plus.plus/categorySave',
            data
        );
    },

    /*删除应用分类*/
    categoryDelete(data) {
        return request._post(
            '/shop/plus.plus/categoryDelete',
            data
        );
    },
}

export default PlusApi;



// WEBPACK FOOTER //
// ./src/api/plus.js